import { createFileRoute } from "@tanstack/react-router";
import { TemplateEditorPage } from "@/features/templates/TemplateEditorPage";

export const Route = createFileRoute("/_app/templates/$kind/$template")({ component: Page });

function Page() {
  const { kind, template } = Route.useParams();
  return <TemplateEditorPage kind={kind} id={template} />;
}
